import { Fragment, type FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { LocationFilter } from "@App/Components/Filters/LocationFilter";
import { actionCreators, State } from "@App/state";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "@reduxjs/toolkit";
import { Place } from "@App/types";
import { Button } from "@App/Components/Funnel/Button";
import { FunnelHeader } from "@App/Components/Funnel/FunnelHeader";

export type LocationProps = {
  headline: string;
  subheadline?: string;
  description?: string;
  step: number;
  maxSteps: number;
  onSubmit?: (place: Place) => void;
};

export const Location: FunctionComponent<LocationProps> = ({
  headline,
  subheadline,
  description,
  step,
  maxSteps,
  onSubmit,
}: LocationProps) => {
  const { t } = useTranslation();

  const place = useSelector((state: State) => state.orders.place);

  const dispatch = useDispatch();
  const { choosePlace } = bindActionCreators(actionCreators, dispatch);

  const submit = (): void => {
    choosePlace(place);
    onSubmit && onSubmit(place);
  };

  return (
    <Fragment>
      <div
        className="
                    container bg-white
                    pt-10 pb-12
                "
      >
        <FunnelHeader
          heading={headline}
          step={step}
          maxSteps={maxSteps}
          subheading={subheadline ? subheadline : t("location.headline")}
          description={description ? description : t("location.subheadline")}
        />
        <div className="w-full md:w-1/3">
          <LocationFilter onSubmit={submit} />
        </div>
        <Button title={t("location.submit")} disabled={place === null} onClick={submit} />
      </div>
    </Fragment>
  );
};
